module.exports = __webpack_public_path__ + "static/media/country_kw.e37272b1.webp";